import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SignInButton from '@/components/SignInButton.vue';
const authenticationModule = namespace('authentication');
const characterModule = namespace('character');
let UserProfile = class UserProfile extends Vue {
    constructor() {
        super(...arguments);
        this.isAuthLoading = false;
    }
    signOut() {
        this.isAuthLoading = true;
        Promise.all([
            this.setAccessToken(),
            this.clearLocalCharacters()
        ]).then(() => {
            Vue.prototype.$msal && Vue.prototype.$msal.logout();
        });
    }
};
__decorate([
    authenticationModule.State
], UserProfile.prototype, "accessToken", void 0);
__decorate([
    authenticationModule.Action
], UserProfile.prototype, "setAccessToken", void 0);
__decorate([
    characterModule.Action
], UserProfile.prototype, "clearLocalCharacters", void 0);
UserProfile = __decorate([
    Component({
        components: {
            SignInButton
        }
    })
], UserProfile);
export default UserProfile;
